import React from 'react'
import { useFela } from 'react-fela'
import { container, debugBorder } from '../../styles/containers'
import { v4 as uuidv4 } from 'uuid'
import { pageTitle } from '../../styles/text'
import PElement from '../containers/PElement'
const componentUUID = uuidv4()
const PTitle = (props: any) => {
  const { title, alignItems, justifyContent, width, fontSize, color, fontWeight, isRow, margin, padding, border } = props
  const flexDirection = isRow ? 'row' : 'column'
  const { css } = useFela()

  const key = `${title}-${componentUUID}`

  return (
    <PElement {...{ alignItems, justifyContent, width, margin, padding, border, flexDirection, isRow }}>
      <span className={css(pageTitle({ fontSize, color, fontWeight, flexDirection, margin, padding, border }))}>{`${title}`}</span>
    </PElement>
  )
}

export default PTitle
